import { modalsVar } from './cache'

export const openModal = (name, modalData) => {
    const data = modalsVar()

    const modal = {
        name,
        data: modalData,
    }

    modalsVar(data.concat(modal))
}

export const closeModal = (name) => {
    const data = modalsVar()
    modalsVar(data.filter((modal) => modal.name !== name))
}
